import { useCallback } from 'react';

import { setFeatureVisited } from '../caching/index.tsx';
import { getMsrFeatureVisitedCount, incrementMsrFeatureVisitedCount } from './caching.tsx';

const SNOOZE_INTERVALS = {
	0: 7,
	1: 14,
	2: 30,
	3: 90,
};

export const useMsrSnoozeHandler = () => {
	const blockEligibilityToPreventRace = useCallback(() => {
		setFeatureVisited('crossJoinNudgesMsr', 0.1);
	}, []);

	const blockEligibilityUntilTomorrow = useCallback((): void => {
		setFeatureVisited('crossJoinNudgesMsr', 1);
	}, []);

	const snooze = useCallback((): void => {
		const visitedCount = getMsrFeatureVisitedCount();
		// We are going to loop the last nudge indefinitely
		const loopedVisitedCount = Math.min(visitedCount, Object.keys(SNOOZE_INTERVALS).length - 1);
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const snoozeInterval = SNOOZE_INTERVALS[loopedVisitedCount as keyof typeof SNOOZE_INTERVALS];
		setFeatureVisited('crossJoinNudgesMsr', snoozeInterval);

		incrementMsrFeatureVisitedCount();
	}, []);

	return { snooze, blockEligibilityUntilTomorrow, blockEligibilityToPreventRace };
};
